// employeePositions/actions.js

import { getAllEmployeePositions } from "../../api/AppDataApi";
import { employeePositionsInitialState } from "./employeePositionsState";

export const makeEmployeePositionsActions = (set, get) => ({
  fetchEmployeePositions: async () => {
    set((s) => ({
      employeePositions: { ...s.employeePositions, loading: true, error: null },
    }));
    try {
      const data = await getAllEmployeePositions();
      set((s) => ({
        employeePositions: {
          ...s.employeePositions,
          loading: false,
          list: data,
        },
      }));
    } catch (err) {
      set((s) => ({
        employeePositions: {
          ...s.employeePositions,
          loading: false,
          error: err.message,
        },
      }));
      console.error("Employee position loading error:", err);
    }
  },
  resetEmployeePositions: () =>
    set({ employeePositions: employeePositionsInitialState }),
});
